import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Error404Component } from './main/errorsPages/404/error-404.component';
import { CognitoGuard } from './core/cognito-guard/cognito-guard';

const routes: Routes = [
  {
    path: 'main',
    loadChildren: () => import('./main/content/sections/sections.module').then(mod => mod.SectionsModule),
    canActivate: [CognitoGuard]
  },
  {
    path: '',
    redirectTo: 'main/home',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: Error404Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
